import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Injectable } from '@angular/core';
import { toKebabCase } from '@js-dot/core';
import * as i1 from '@ng-dot/core';
class DotDockStyleComponent {
  componentRef;
  static ɵfac = function DotDockStyleComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotDockStyleComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotDockStyleComponent,
    selectors: [["ng-component"]],
    inputs: {
      componentRef: "componentRef"
    },
    decls: 0,
    vars: 0,
    template: function DotDockStyleComponent_Template(rf, ctx) {},
    styles: [".dot_top,.dot_top-left,.dot_top-center,.dot_top-right,.dot_bottom,.dot_bottom-left,.dot_bottom-center,.dot_bottom-right{position:fixed}.dot_top,.dot_top-left,.dot_top-center,.dot_top-right{top:0}.dot_bottom,.dot_bottom-left,.dot_bottom-center,.dot_bottom-right{bottom:0}.dot_top,.dot_bottom{left:0;right:0}.dot_top-left,.dot_bottom-left{left:0}.dot_top-center,.dot_bottom-center{left:50%;transform:translate(-50%)}.dot_top-right,.dot_bottom-right{right:0}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotDockStyleComponent, [{
    type: Component,
    args: [{
      standalone: true,
      template: ``,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      styles: [".dot_top,.dot_top-left,.dot_top-center,.dot_top-right,.dot_bottom,.dot_bottom-left,.dot_bottom-center,.dot_bottom-right{position:fixed}.dot_top,.dot_top-left,.dot_top-center,.dot_top-right{top:0}.dot_bottom,.dot_bottom-left,.dot_bottom-center,.dot_bottom-right{bottom:0}.dot_top,.dot_bottom{left:0;right:0}.dot_top-left,.dot_bottom-left{left:0}.dot_top-center,.dot_bottom-center{left:50%;transform:translate(-50%)}.dot_top-right,.dot_bottom-right{right:0}\n"]
    }]
  }], null, {
    componentRef: [{
      type: Input
    }]
  });
})();
class DotDockService {
  _core;
  _component;
  constructor(_core, _component) {
    this._core = _core;
    this._component = _component;
    _component.append(DotDockStyleComponent);
  }
  add(position, poolComponent, itemComponent) {
    return this._component.pool(poolComponent, itemComponent, {
      className: 'dot_' + toKebabCase(position)
    });
  }
  static ɵfac = function DotDockService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotDockService)(i0.ɵɵinject(i1.DotCoreService), i0.ɵɵinject(i1.DotComponentService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotDockService,
    factory: DotDockService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotDockService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.DotCoreService
  }, {
    type: i1.DotComponentService
  }], null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DotDockService, DotDockStyleComponent };
